import { render, staticRenderFns } from "./ServiceContent.vue?vue&type=template&id=e83bcfd6&"
import script from "./ServiceContent.vue?vue&type=script&lang=js&"
export * from "./ServiceContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports